import { useQuery } from 'react-query';
import { listSandboxes, getSandbox, listRegistrations, getRegistration } from './sales-demo.api';

type PageParams = { pageSize?: number; pageToken?: string; filter?: string };

export const salesDemoQueryKeys = {
  sandboxList: (params: PageParams) => ['sales-demo', 'sandboxes', params] as const,
  sandbox: (id: string) => ['sales-demo', 'sandbox', id] as const,
  registrationList: (params: PageParams) => ['sales-demo', 'registrations', params] as const,
  registration: (id: string) => ['sales-demo', 'registration', id] as const,
};

export const useListSandboxesQuery = (params: PageParams = {}) =>
  useQuery(salesDemoQueryKeys.sandboxList(params), () => listSandboxes(params));

export const useGetSandboxQuery = (sandboxId: string) =>
  useQuery(salesDemoQueryKeys.sandbox(sandboxId), () => getSandbox(sandboxId), { enabled: !!sandboxId });

export const useListRegistrationsQuery = (params: PageParams = {}) =>
  useQuery(salesDemoQueryKeys.registrationList(params), () => listRegistrations(params));

export const useGetRegistrationQuery = (registrationId: string) =>
  useQuery(salesDemoQueryKeys.registration(registrationId), () => getRegistration(registrationId), {
    enabled: !!registrationId,
  });
